import axios from "axios"

export const deleteUtente = (id: number) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(`/api/UtenteOttico/${id}`)
      .then(() => {
        resolve(true)
      })
      .catch((error) => {
        reject(error.response.data.response)
      })
  })
}
export default deleteUtente
